// extracted by mini-css-extract-plugin
export var base = "_4i-0";
export var updateBanner = "_4i-1";